import React, { useEffect, useState } from "react";
import {
  Button, Input, Typography, 
 Toast, Card,
} from "@douyinfe/semi-ui";
import { ApiClient } from "../../api/ApiClient";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const api = ApiClient.getDefault();

/* ==================== 登录页 ==================== */
function FieldRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 8, gap: 8 }}>
      <div style={{ width: 70, textAlign: "right", flexShrink: 0, fontSize: 13, color: "#666" }}>{label}</div>
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
}

export default function OpsLogin() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    try {
      const req:any = {
          mobile, password, captcha: "not"
      }
      const resp = await api.logIn(req);
      if (resp.data) {
        Toast.success("登录成功");
        let user = await api.getCurrentAdmin();
      localStorage.setItem("username", user.data.username);
      localStorage.setItem("userId", String(user.data.id));
      localStorage.setItem("userRealName", user.data.name);
      localStorage.setItem("teamId", String(user.data.teamId));
      localStorage.setItem("teamName", user.data.teamName);
      localStorage.setItem("role", user.data.role);
      localStorage.setItem("city", user.data.city);
        navigate("/opsAssistant");
      }
    } catch (e: any) {
      Toast.error(e?.message || "登录失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", background: "#f5f5f5" }}>
      <Card style={{ width: 360, padding: 24 }} title={<Text strong style={{ fontSize: 18 }}>运维助手</Text>}>
        <FieldRow label="手机号"><Input value={mobile} onChange={setMobile} /></FieldRow>
        <FieldRow label="密码"><Input mode="password" value={password} onChange={setPassword} onEnterPress={handleLogin} /></FieldRow>
        <Button theme="solid" loading={loading} onClick={handleLogin} block style={{ marginTop: 12 }}>登录</Button>
      </Card>
    </div>
  );
}